export default __webpack_public_path__ + "static/media/dmpc.e121c5c3.svg";